// JavaScript Document

/************************************************************
MVアニメーション
************************************************************/
//ループ機能

//時間設定
var interval = 5000;
var current = 1;

$(window).on('load', function(event) {
	var timer = setInterval(slideAnimation, interval);
});

function slideAnimation() {
	$('.ms_slide li:nth-child(2)').toggleClass('current');
	$('.ms_slide li:nth-child(2) img').toggleClass('current');
}


$(function(){


	/************************************************************
	スクロール
	************************************************************/

	$('.menshokunin a[href^="#"],.ms_floating a[href^="#"],.ms_nav a[href^="#"]').click(function() {
          // スクロールの速度
          var speed = 400; // ミリ秒で記述
          var href= $(this).attr("href");
          var target = $(href == "#" || href == "" ? 'html' : href);
           if($(window).width() > 787){
			var position = target.offset().top + -77;
		}else{
			var position = target.offset().top + -100;
		}
          $('body,html').animate({scrollTop:position}, speed, 'swing');
          return false;
        });

	/************************************************************
	PC-SP画像切り替え
	************************************************************/

	//切り替えポイント
	var rwdPoint=600;

	function ImgChange(){
		if(window.innerWidth <  rwdPoint){
            $("img.rwd").each(function(){
				var changeImg = $(this).attr('src').replace('-pc.' , '-sp.');
				$(this).attr('src', changeImg);
			});
		}else{
			$("img.rwd").each(function(){
				var changeImg = $(this).attr('src').replace('-sp.' , '-pc.');
				$(this).attr('src', changeImg);
			});
		}
	}
	//読み込み時の処理
	ImgChange();

    //リサイズ時の処理
    $(window).resize(function () {
		ImgChange();
    });
	
	
jQuery(function($){
  // 置換の対象とするclass属性。
  var $elem = $('.js-image-switch');
  // 置換の対象とするsrc属性の末尾の文字列。
  var sp = '-sp.';
  var pc = '-pc.';
  // 画像を切り替えるウィンドウサイズ。
  //var replaceWidth = 768;

  function imageSwitch() {
    // ウィンドウサイズを取得する。
    var windowWidth = parseInt(window.innerWidth);

    // ページ内にあるすべての`.js-image-switch`に適応される。
    $elem.each(function() {
      var $this = $(this);
      replaceWidth = $(this).data('image-switch');//画像を切り替えるウィンドウサイズ。data-image-switch
      // ウィンドウサイズが768px以上であれば-spを-pcに置換する。
      if(windowWidth >= replaceWidth) {
        $this.attr('src', $this.attr('src').replace(sp, pc));

      // ウィンドウサイズが768px未満であれば-pcを-spに置換する。
      } else {
        $this.attr('src', $this.attr('src').replace(pc, sp));
      }
    });
  }
  imageSwitch();

  // 動的なリサイズは操作後0.2秒経ってから処理を実行する。
  var resizeTimer;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      imageSwitch();
    }, 200);
  });
});
/*
<img src="hoge-pc.png" alt="" class="js-image-switch" data-image-switch="768">
data-image-switchで切り替える幅を指定
*/


	/************************************************************
	slick
	************************************************************/
	/*
$('.slider').slick({
    autoplay:true,
    autoplaySpeed:4000,
    dots:true,
    slidesToShow:1,
    slidesToScroll:1,
	accessibility:false,
	speed:400,
	pauseOnFocus:false,
	pauseOnHover:false,
	arrows: false,
});
*/
	// メニュー開閉
	
$('.hnav6 a').click(function () {
  $('.hnav6 ul li').addClass('open');
});
	
	$(document).on('click touchend',   function(e) {
  if (!$(e.target).closest('.hnav6 a').length) {
     $('.hnav6 ul li').removeClass('open');
  }
});

$(".hnav6 ul li a").click(function () {
    $('.hnav6 ul li').removeClass('open');
});
	
	
});
